<template>
  <div class="cloud-container">
    <!-- Select DB Type -->
    <div v-if="isShowSelectDb" class="cloud-menu">
      <h4>{{ $t('aws.selectDbType') }}:</h4>
      <RexSelectV3
        :customStyle="{ width: '14.6rem', height: '2.5em' }"
        :value="selectedDbType"
        :options="data"
        @onChange="handleDbTypeChange"
        id="search-select-dbtype"
      />
    </div>

    <div class="cloud-menu">
      <h4>{{ $t('aws.selectConnectionName') }}:</h4>
      <RexSelectV3
        :customStyle="{ width: '14.6rem', height: '2.5em' }"
        :placeholder="
          $t('aws.rdsOverviewScreen.subscriptionDropdownPlaceholder')
        "
        :options="filteredSubscription"
        @onChange="onSubscriptionIdChange"
        mode="multiple"
        :maxTagTextLength="5"
        :maxTagCount="1"
        v-model:value="selectedSubscriptionArray"
        id="search-select-subscriptionId"
      />
    </div>
  </div>
</template>

<script>
import RexSelectV3 from '@/rex-components/RexSelectV3.vue';
import { dbTypes } from '@/components/Cloud/Dashboard/cloud.types';
import { mapGetters, mapState } from 'vuex';

export default {
  components: { RexSelectV3 },
  name: 'AWSHeader',
  props: {
    data: {
      type: Array,
      default: () => [],
    },
    subscriptions: {
      type: Array,
      required: true,
    },
    isShowSelectDb: {
      type: Boolean,
      required: true,
    },
  },
  emits: ['handleSubscriptionSelect', 'dbTypeChanged'],
  data() {
    return {
      selectedDbType: '',
      filteredSubscription: [],
      selectedSubscriptionArray: [],
    };
  },
  computed: {
    ...mapGetters('globalState/settings', ['getDurationTime', 'intervalTime']),
    ...mapState('cloudState/detail', ['currentSubType', 'currentServices']),
  },
  watch: {
    subscriptions(currentValue) {
      this.updateFilteredSubscription(currentValue);
    },
    getDurationTime(currentValue) {
      this.selectedSubscriptionArray = this.filteredSubscription
        .filter((subscription) =>
          this.currentServices.includes(subscription.value),
        )
        .map((subscription) => subscription.key);
    },
  },
  beforeMount() {
    // Initialize selectedSubscriptionArray with at most 5 items
    this.initialDbType();
  },
  methods: {
    updateFilteredSubscription(subscriptions) {
      // Update filteredSubscription with the latest subscriptions
      this.filteredSubscription = subscriptions.map((subscription) => ({
        value: subscription.key,
        label: subscription.label,
      }));

      this.selectedSubscriptionArray = subscriptions
        .filter((subscription) =>
          this.currentServices.includes(subscription.key),
        )
        .map((subscription) => subscription.key);
    },
    onSubscriptionIdChange(selectedItem, otherOptions) {
      if (selectedItem.length > 5) {
        return;
      } else {
        this.selectedSubscriptionArray = selectedItem;
      }

      // Emit the selected labels as needed
      this.$emit(
        'handleSubscriptionSelect',
        otherOptions.map((option) => option.label),
      );
    },
    initialDbType() {
      const match = this.data.find((item) =>
        this.currentSubType.toLowerCase().includes(item.value.toLowerCase()),
      );
      if (match) {
        this.selectedDbType = match.label;
      } else {
        // Optionally handle the case where no match is found
        this.selectedDbType = this.data[0] ? this.data[0].label : null;
      }
    },

    handleDbTypeChange(selectedDbType) {
      let emitValue = '';
      if (!dbTypes[selectedDbType.toLowerCase()]) {
        emitValue = '';
      } else {
        emitValue = dbTypes[selectedDbType.toLowerCase()];
      }

      // Emit the determined value
      if (emitValue) {
        this.$emit('dbTypeChanged', emitValue);
      }

      // Update local state
      this.selectedDbType = selectedDbType;
    },
  },
};
</script>

<style lang="scss" scoped>
.cloud-container {
  display: flex;
  align-items: center;
  gap: 5rem;
}
.cloud-menu {
  display: flex;
  align-items: center;
  gap: 1rem;
}
.main-container {
  @include flex-column;
}
</style>
